/* BFCM 2026 — window.RBSale. The single source of truth for sale time, tier
   maths and money. Every later BFCM module reads this and computes nothing.

   THREE RULES THIS FILE EXISTS TO ENFORCE (CLAUDE.md BFCM 1, 2, 6):
     1. Tier maths comes only from progress().
     2. Sale state comes only from state() (the cart drawer's settings, never
        the clock); countdowns only from countdown(). No module calls Date.
     3. The qualifying subtotal mirrors AutoCart exactly: cart.total_price —
        after every discount, INCLUDING Shipping Protection — minus gift lines.

   Loaded defer from layout/theme.liquid, and only when the sale is enabled. */
(function () {
  'use strict';

  var EL = document.getElementById('rb-sale-data');
  if (!EL) return;

  var DATA;
  try { DATA = JSON.parse(EL.textContent); } catch (e) { return; }
  if (!DATA || DATA.enabled !== true) return;

  /* ---- STATE AND TIME -----------------------------------------------------
     STATE IS SET BY HAND (28 Sep 2026). Sale state, Free Shipping Friday and
     Last chance are settings on the cart drawer, delivered in DATA.state.
     Nothing here switches state on a date: state() returns the settings, in
     the same shape as when it was clock-driven, so no module changed.

     Dates are countdown TARGETS only (saleStart, saleEnd, fsfEnd). A
     countdown at zero returns done: true and the module hides it. There is no
     time override any more; to test a state, change the setting. */
  function now() { return Date.now(); }

  /* An unparseable date warns and its countdown reads done (hidden), which is
     visible in the debug overlay. */
  function parse(key) {
    var raw = (DATA.dates || {})[key];
    if (raw === undefined || raw === null || raw === '') return null;
    var t = Date.parse(raw);
    if (isNaN(t)) { console.warn('[RBSale] unparseable date for ' + key + ':', raw); return null; }
    return t;
  }
  var D = {
    saleStart: parse('saleStart'),
    saleEnd: parse('saleEnd'),
    fsfEnd: parse('fsfEnd')
  };

  var ST = DATA.state || {};
  var PHASE = (ST.phase === 'live' || ST.phase === 'ended') ? ST.phase : 'pre';
  function state() {
    var last = PHASE === 'live' && ST.lastChance === true;
    return {
      phase: PHASE,
      /* Last chance drives both: the 3.1 band (finalHours) and the 3.2 bar
         and F's time-left figure (finalWeekend). */
      finalHours: last,
      finalWeekend: last,
      fsf: ST.fsf === true,
      /* Gift promo: the 3.3 tracker and the pill only (1 Oct 2026). */
      gwp: ST.gwp === true
    };
  }

  /* offsetMs (optional, 30 Oct 2026): count down to the target PLUS an
     offset, e.g. countdown('saleStart', 3600000) is the end of a window that
     opens at sale start. Display only, like every countdown here. */
  function countdown(targetKey, offsetMs) {
    var target = D[targetKey];
    if (target === null || target === undefined) return { d: 0, h: 0, m: 0, s: 0, done: true };
    var ms = target + (Number(offsetMs) || 0) - now();
    if (ms <= 0) return { d: 0, h: 0, m: 0, s: 0, done: true };
    var s = Math.floor(ms / 1000);
    return {
      d: Math.floor(s / 86400),
      h: Math.floor((s % 86400) / 3600),
      m: Math.floor((s % 3600) / 60),
      s: s % 60,
      done: false
    };
  }

  /* ---- BODY CLASSES -------------------------------------------------------
     Written before first paint by the inline script in
     sections/cart-drawer.liquid, from the same settings. Re-applied here once
     as a fallback; with state no longer on the clock they never change
     mid-page. */
  var CLASSES = ['rb-sale-pre','rb-sale-live','rb-sale-ended','rb-sale-final-hours','rb-sale-final-weekend','rb-sale-fsf','rb-gwp-live'];
  function applyClasses(st) {
    var b = document.body;
    if (!b) return;
    CLASSES.forEach(function (c) { b.classList.remove(c); });
    if (st.gwp) b.classList.add('rb-gwp-live');
    /* Gift promo with the sale switched off: no rb-sale-* class at all, so
       nothing but the tracker and pill reacts. */
    if (ST.saleEnabled === false) return;
    b.classList.add('rb-sale-' + st.phase);
    if (st.finalHours) b.classList.add('rb-sale-final-hours');
    if (st.finalWeekend) b.classList.add('rb-sale-final-weekend');
    if (st.fsf) b.classList.add('rb-sale-fsf');
  }

  /* ---- MONEY --------------------------------------------------------------
     NO ×100 ANYWHERE. Every amount — thresholds, gift values, cart totals —
     is already in the subunits cart.js uses, confirmed for HUF and SEK. */
  function money(subunits) {
    /* A PORT OF SHOPIFY'S formatMoney, and it must cover every separator style
       this shop actually uses — not just the comma ones. Measured live:
         AUD  ${{amount}}
         SEK  {{amount_with_space_separator}} kr
         HUF  {{amount_no_decimals_with_comma_separator}} Ft
         ISK  {{amount_no_decimals}} kr
       An earlier version fell through to the comma formatter for anything it
       did not recognise, which rendered SEK as "1,300.00 kr" instead of
       "1 300,00 kr".

       NO ×100. Verified against /cart.js in HUF: a 50ml EDP returns 3660000,
       which is 36,600 Ft — cart.js reports HUF in hundredths like every other
       currency, so the stored thresholds are already in the right units. */
    var fmt = DATA.moneyFormat || '${{amount}}';
    var n = Number(subunits) || 0;

    function group(cents, places, thousands, decimal) {
      var fixed = (cents / 100).toFixed(places);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+$)/g, '$1' + thousands);
      return places > 0 ? whole + decimal + parts[1] : whole;
    }

    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount':                                   return group(n, 2, ',', '.');
        case 'amount_no_decimals':                       return group(n, 0, ',', '.');
        case 'amount_with_comma_separator':              return group(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':  return group(n, 0, '.', ',');
        case 'amount_with_space_separator':              return group(n, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator':  return group(n, 0, ' ', ',');
        case 'amount_with_apostrophe_separator':         return group(n, 2, "'", '.');
        default:                                         return group(n, 2, ',', '.');
      }
    });
  }

  /* ---- CART AND PROGRESS --------------------------------------------------- */
  var cart = null;
  var EXCLUDE = {};
  (DATA.excludeVariantIds || []).forEach(function (id) { EXCLUDE[String(id)] = true; });

  var T1 = (DATA.tiers && DATA.tiers.t1) || {};
  var T2 = (DATA.tiers && DATA.tiers.t2) || {};
  if (Number(T1.threshold) > 0 && Number(T2.threshold) > 0 &&
      Number(T2.threshold) <= Number(T1.threshold)) {
    console.warn('[RBSale] Tier Two threshold (' + T2.threshold + ') is not above Tier One (' +
                 T1.threshold + '). Check the currency block for this market — remember ' +
                 'tier-three-amount IS Tier One and tier-four-amount IS Tier Two.');
  }

  function qualifyingSubtotal() {
    if (!cart) return 0;
    /* total_price is after line AND cart-level discounts and excludes
       shipping — the same number AutoCart tests. Shipping Protection is a
       normal line and is deliberately counted. Gift lines are removed by
       whatever they actually carry, which is usually 0 after AutoCart's own
       discount but must not be assumed. */
    var total = cart.total_price || 0;
    (cart.items || []).forEach(function (it) {
      if (EXCLUDE[String(it.variant_id)]) total -= (it.final_line_price || 0);
    });
    return total < 0 ? 0 : total;
  }

  function progress(extraSubunits) {
    var extra = Number(extraSubunits) || 0;
    var subtotal = qualifyingSubtotal();
    var projected = subtotal + extra;
    var t1 = Number(T1.threshold) || 0;
    var t2 = Number(T2.threshold) || 0;
    /* AutoCart uses "greater or equal". */
    var t1Reached = t1 > 0 && projected >= t1;
    var t2Reached = t2 > 0 && projected >= t2;
    /* MONOTONIC. Tier two is only "reached" on top of tier one, so a module
       can never be handed tier 2 alongside t1Reached false. That is not
       hypothetical: AU's context overlays tier-four-amount to 2000 against a
       tier-three-amount of 15000, so Tier Two sits BELOW Tier One and a $129
       cart reported tier 2 with tier 1 unmet. The flags stay literal — each
       is a fact about its own threshold — but `tier` stays coherent. */
    var tier = (t2Reached && t1Reached) ? 2 : (t1Reached ? 1 : 0);
    var gap = 0;
    if (!t1Reached && t1 > 0) gap = t1 - projected;
    else if (!t2Reached && t2 > 0) gap = t2 - projected;
    return {
      subtotal: subtotal,
      projected: projected,
      tier: tier,
      gap: gap > 0 ? gap : 0,
      pctToT2: t2 > 0 ? Math.max(0, Math.min(1, projected / t2)) : 0,
      t1Reached: t1Reached,
      t2Reached: t2Reached
    };
  }

  function emitCart() {
    document.dispatchEvent(new CustomEvent('rb:sale:cart', { detail: progress(0) }));
  }

  var fetching = false;
  function refresh() {
    if (fetching) return Promise.resolve(cart);
    fetching = true;
    return fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js',
                 { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; emitCart(); return c; })
      .catch(function () { return cart; })
      .then(function (c) { fetching = false; return c; });
  }

  /* ---- CART CHANGE DETECTION ---------------------------------------------
     THREE SOURCES, ONE FETCH. Dawn publishes cart-update through pubsub.js;
     the custom drawer publishes NOTHING on update — mini-cart.js's fetchCart()
     swaps .drawer__inner innerHTML silently — so quantity changes and line
     removals, the two interactions most likely to cross a tier, would never be
     seen without the observer.

     All three funnel through one debounce so a single drawer interaction costs
     exactly one /cart.js. */
  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () { timer = null; refresh(); }, 250);
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
  }
  document.addEventListener('theme:product:add', schedule);
  (function observeDrawer() {
    if (typeof MutationObserver !== 'function') return;
    var inner = document.querySelector('#cart-drawer .drawer__inner');
    if (!inner) return;
    new MutationObserver(schedule).observe(inner, { childList: true, subtree: true });
  })();

  /* ---- ADD ----------------------------------------------------------------
     A thin wrapper over the theme's existing AJAX add. It never implements a
     second add path: it posts to the same endpoint the rest of the site uses,
     then hands off to the drawer's own globals. */
  /* opts.open === false (AOV grower steppers, Oct 2026): add WITHOUT opening or
     re-rendering the drawer — the caller refreshes the drawer silently itself,
     since fetchCart() always opens it. Default unchanged: every existing call
     still opens the drawer. */
  function add(items, opts) {
    var silent = !!(opts && opts.open === false);
    var body = Array.isArray(items) ? { items: items } : { items: [items] };
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed ' + r.status); return r.json(); })
      .then(function () {
        /* toggleCart(doClose = false) with no argument opens a CLOSED drawer —
           but on an OPEN one it falls through to its close branch
           (mini-cart.js), so an add made from inside the drawer (the 3.7
           stepper, the 3.6 set button with the drawer up) closed the drawer it
           was adding from. Only open what is shut; fetchCart() re-renders
           either way. */
        if (!silent) {
          var drawer = document.getElementById('cart-drawer');
          var isOpen = drawer && drawer.classList.contains('is-drawer-open');
          if (!isOpen && typeof window.toggleCart === 'function') window.toggleCart();
          if (typeof window.fetchCart === 'function') window.fetchCart();
        }
        return refresh();
      });
  }

  /* ---- TICKER — one interval for the whole page ---------------------------
     Drives the countdowns only. rb:sale:phase is no longer fired: state
     cannot change without a page load. Modules still listening for it are
     harmless. */
  applyClasses(state());
  setInterval(function () {
    document.dispatchEvent(new CustomEvent('rb:sale:tick', { detail: state() }));
  }, 1000);

  window.RBSale = {
    data: DATA,
    now: now,
    state: state,
    countdown: countdown,
    progress: progress,
    money: money,
    add: add,
    refresh: refresh,
    get cart() { return cart; },
    reducedMotion: window.matchMedia('(prefers-reduced-motion: reduce)').matches
  };

  refresh();

  /* ---- DEBUG OVERLAY ------------------------------------------------------ */
  (function debug() {
    var q = new URLSearchParams(location.search);
    var DK = 'rb_sale_debug';
    if (q.get('rb_sale_debug') === '1') { try { sessionStorage.setItem(DK, '1'); } catch (e) {} }
    if (q.get('rb_sale_debug') === '0') { try { sessionStorage.removeItem(DK); } catch (e) {} return; }
    var on = false;
    try { on = sessionStorage.getItem(DK) === '1'; } catch (e) {}
    if (!on) return;

    var box = document.createElement('div');
    box.setAttribute('data-rb-sale-debug', '');
    box.style.cssText = 'position:fixed;left:8px;bottom:8px;z-index:99999;max-width:320px;' +
      'background:rgba(0,0,0,.86);color:#fff;font:11px/1.45 ui-monospace,monospace;' +
      'padding:10px 12px;border-radius:6px;white-space:pre-wrap;pointer-events:none';
    document.body.appendChild(box);
    function paint() {
      var st = state(), p = progress(0), s = DATA.stock || {};
      box.textContent =
        'market ' + DATA.market + '  ' + DATA.currency + '\n' +
        'state ' + st.phase + '  lastChance:' + (st.finalHours ? 1 : 0) +
          ' fsf:' + (st.fsf ? 1 : 0) + '  (settings)\n' +
        'now   ' + new Date(now()).toISOString() + '\n' +
        ['saleStart','saleEnd','fsfEnd'].map(function (k) {
          var c = countdown(k);
          return k + ' ' + (c.done ? 'done' : c.d + 'd ' + c.h + 'h ' + c.m + 'm ' + c.s + 's');
        }).join('\n') + '\n' +
        'subtotal ' + p.subtotal + '  proj ' + p.projected + '\n' +
        'tier ' + p.tier + '  gap ' + p.gap + '  pctT2 ' + p.pctToT2.toFixed(3) + '\n' +
        't1 ' + T1.threshold + ' stock ' + JSON.stringify(s.t1) + '\n' +
        't2 ' + T2.threshold + ' stock ' + JSON.stringify(s.t2) + '\n' +
        'excluded variants ' + (DATA.excludeVariantIds || []).length;
    }
    paint();
    document.addEventListener('rb:sale:tick', paint);
    document.addEventListener('rb:sale:cart', paint);
  })();
})();
